import { axiosClient, TPagination } from "@/configurations/axios"
import { queryClient } from "@/configurations/react-query"
import {
  MYSESSION_ENDPOINTS,
  MYSESSION_KEYS
} from "@/features/my-session/configs/endpoints"
import { TMySessionData } from "@/features/my-session/types"
import { queryOptions } from "@tanstack/react-query"

const getMySessionList = async () => {
  const response = await axiosClient.get<TPagination<TMySessionData>>(
    MYSESSION_ENDPOINTS.getMySessionList
  )
  return response.data.data
}

export const getMySessionListQueryOptions = () => {
  return queryOptions({
    queryKey: MYSESSION_KEYS.mySessionList(),
    queryFn: getMySessionList
  })
}

export const getMySessionListLoader = () => {
  return queryClient.ensureQueryData(getMySessionListQueryOptions())
}
